export default "__VITE_ASSET__579um1jr__"